import { Button } from '@vfit/shared/atoms';
import { ICTAContainerProps } from './productCardCTAContainer.models';
import { AboveLabel, Wrapper } from './productCardCTAContainer.style';

const ProductCardCTAContainer = ({
  hideFirstButton,
  aboveText,
  firstButtonAction,
  firstButtonLabel,
  firstButtonName,
  secondButtonAction,
  secondButtonLabel,
  secondButtonName,
  secondButtonVariant,
  thirdButtonAction,
  thirdButtonLabel,
  thirdButtonName,
  thirdButtonVariant,
}: ICTAContainerProps) => (
  <Wrapper>
    {aboveText && <AboveLabel dangerouslySetInnerHTML={{ __html: aboveText }} />}
    {firstButtonLabel && !hideFirstButton && (
      <Button variant="primary" onClick={firstButtonAction} name={firstButtonName || ''}>
        {firstButtonLabel}
      </Button>
    )}
    {secondButtonLabel && secondButtonAction && (
      <Button
        variant={secondButtonVariant || 'secondary'}
        onClick={secondButtonAction}
        name={secondButtonName || ''}
      >
        {secondButtonLabel}
      </Button>
    )}
    {thirdButtonLabel && thirdButtonAction && (
      <Button
        variant={thirdButtonVariant || 'secondary'}
        onClick={thirdButtonAction}
        name={thirdButtonName || ''}
      >
        {thirdButtonLabel}
      </Button>
    )}
  </Wrapper>
);

export default ProductCardCTAContainer;
